import { Component, OnInit } from '@angular/core';
import { TooltipBehavior, TooltipPosition, TooltipTheme } from '../../../model/entity';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrl: './tooltip.component.scss'
})
export class TooltipComponent implements OnInit {
    
    tooltipText: string = "";
    tooltipSecondaryText;
    
    tooltipPosition: TooltipPosition = TooltipPosition.DEFAULT;
    tooltipTheme: TooltipTheme = TooltipTheme.DEFAULT;
    tooltipBehavior: TooltipBehavior = TooltipBehavior.DEFAULT;

    absoluteHorizontalPosition: number = 0;
    absoluteVerticalPosition: number = 0;
    
    tooltipWidth: number = 0;

    mouseHorizontalPosition: number = 0;
    mouseVerticalPosition: number = 0;

    constructor() {}

    ngOnInit() {
        console.log("TooltipComponenet - ngOnInit() - tooltipTheme: " + this.tooltipTheme);
        console.log("TooltipComponenet - ngOnInit() - tooltipTheme: " + this.tooltipBehavior);
    }
}
